<template>
    <div class="page-layout blank contacts-manage">
        <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center mt-40">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div v-else class="pb-10 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-between align-items-center">
                    <div class="breadcrumbnew">
                        <div><router-link to="/salesDashboard" class="text-white pl-2 text-line">Sales Dashboard</router-link></div>
                        <span>Campaign</span>
                    </div>
                    <div class= "d-flex justify-content-between align-items-center">
                        <button class="btn btn-des-small ml-2 mr-6 float-right text-white" v-if="userPermissions.campaigns.permitted_actions.create" @click="goToCreateEmailCampaign" style="background:#128807; height:30px">+ Create New Campaign</button>
                        <!-- <div  class="d-flex mr-6">
                            <el-dropdown trigger="click" class="ml-4">
                                <button class="btn btn-new-green btn-wide">+ Create New Campaign</button >
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="goToCreateEmailCampaign">Create Email Campaign</el-dropdown-item>
                                    <el-dropdown-item @click.native="goToCreateSmsCampaign">Create SMS Campaign</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div> -->
                        <div class= "d-flex justify-content-between align-items-center">
                            <div class="dropdown-label">Period : </div>
                            <div class="dropdown perioddropdown">
                                <ul class='nav nav-tabs'>
                                    <li class='nav-item dropdown'>
                                    <a aria-expanded='false' aria-haspopup='true' class='nav-link dropdown-toggle dropdown-button on-focus' data-toggle='dropdown' href='#' role='button'>
                                        <span v-if="this.period_data == 'fiscal_year'">Fiscal Year</span>
                                        <span v-if="period_data == 'h1'">Semi Annual H1</span>
                                        <span v-if="period_data == 'h2'">Semi Annual H2</span>
                                        <span v-if="period_data == 'q1'">Quarter Q1</span>
                                        <span v-if="period_data == 'q2'">Quarter Q2</span>
                                        <span v-if="period_data == 'q3'">Quarter Q3</span>
                                        <span v-if="period_data == 'q4'">Quarter Q4</span>
                                        <span v-if="this.period_data == 'month'">Month</span>
                                    </a>
                                    <div class='dropdown-menu period-dropdown-menu'>
                                        <a @click="getData('fiscal_year')" class='dropdown-item' href='#'>Fiscal Year</a>
                                        <div class='dropdown-item dropdown-submenu period-dropdown'>
                                        <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown' href='#'>Semi-Annual</a>
                                        <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                            <a @click="getData('h1')"  class='dropdown-item' href='#'>H1</a>
                                            <a @click="getData('h2')"  class='dropdown-item' href='#'>H2</a>
                                        </div>
                                        </div>
                                        <div class='dropdown-item dropdown-submenu period-dropdown'>
                                        <a class='dropdown-item dropdown-item-toggle' data-toggle='dropdown' href='#'>Quarter</a>
                                        <div class='dropdown-menu period-dropdown-menu sub-dropdown'>
                                            <a @click="getData('q1')"  class='dropdown-item' href='#'>Q1</a>
                                            <a @click="getData('q2')"  class='dropdown-item' href='#'>Q2</a>
                                            <a @click="getData('q3')"  class='dropdown-item' href='#'>Q3</a>
                                            <a @click="getData('q4')"  class='dropdown-item' href='#'>Q4</a>
                                        </div>
                                        </div>
                                        <a @click="getData('month')" class='dropdown-item' href='#'>Month</a>
                                    </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <!-- Ongoing Campaign list Section -->
                <div class="col-lg-8 col-sm-12 col-md-12 mt-3">
                    <fullscreen class="box-radius bg-white" ref="camp_list" @change="dataChange('camp_list')" >
                        <div class="card-item deals-cards bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center">
                                <div class="fw-600 pr-5 fs-14">Ongoing Campaigns List</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('camp_list'), campList()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>

                            <div class="pl-4 pr-2">
                                <div id="campListValue" class="mt-3 campListValue">
                                    <table class="table table-properties team-listview-table text-left w-100 ">
                                        <thead style="width: 100% !important;">
                                            <tr>
                                                <th class="whiteSpace pl-7" style="width: 30% !important;">Campaign Name</th>
                                                <th class="whiteSpace" style="width: 20% !important;">Campaign Type</th>
                                                <!-- <th class="whiteSpace">Industry Type</th> -->
                                                <th class="whiteSpace" style="width: 20% !important;">Budget ({{currency_symbol}})</th>
                                                <th class="whiteSpace" style="width: 30% !important;">Period</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="w-100" v-if="ajaxCallInProgress_campList">
                                                <td colspan="15">
                                                    <div class="d-flex align-items-center justify-content-center w-100">
                                                        <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-else-if="!ajaxCallInProgress_campList && campaigns_list.length == 0" class="text-center">
                                                <td colspan="15">
                                                    <img src="/static/images/territory-sales.png" class="mb-3 pt-3 sales-list" style="width:50% !important; height:50% !important;"/>
                                                    <div class="text-center text-muted fw-500">No Campaigns found!</div>
                                                </td>
                                            </tr>
                                            <template v-else v-for="(campaigns, index) in campaigns_list" >
                                                <tr class="camp-table-row" @click="loadCampaignDetails(campaigns._id, campaigns.name, campaigns.type, campaigns.start_date, campaigns.category_id)" :key="index" v-on:click="selectItem(index)" v-bind:class="{ active: index === activeItem }">
                                                    <td class="pointer text-color text-truncate cell-width pl-8" :title="campaigns.name">{{ campaigns.name }}</td>
                                                    <td>{{ campaigns.type }}</td>
                                                    <!-- <td class="text-truncate cell-width" :title="campaigns.industry_type">{{ campaigns.industry_type }}</td> -->
                                                    <td>{{ campaigns.budget || "-" }}</td>
                                                    <td class="w-1" style="white-space: nowrap">{{ campaigns.start_date.replaceAll("-","/") }} <span v-if="campaigns.end_date"> - </span>{{ campaigns.end_date ? campaigns.end_date.replaceAll("-","/") : '' }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Campaign Statistics Section -->
                <div class="col-lg-4 col-md-12 clo-sm-12 p-0">
                    <fullscreen ref="camp_stats" @change="dataChange('camp_stats')" class="mr-3 box-radius bg-white">
                        <div class="d-flex align-items-center justify-content-center mt-3" v-if="loadCampaignStatisticSection" style="height: 410px;">
                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div v-else class="bg-white mt-3 mr-2 box-radius">
                            <div class="d-flex justify-content-between align-items-center pl-4 pt-4 pr-2 pb-3">
                                <div class="fw-600 fs-14 text-truncate cell-width-name" :title="selected_campaign_name + ' Campaign Statistics'">{{ selected_campaign_name }} Campaign Statistics</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('camp_stats'), campStatsExpand()">
                                    <img class="expand-img" src="/static/images/dashboard/expand_logo.svg" alt />
                                </button>
                            </div>
                            <div id="campStatsDiv" class="campStatsDiv"></div>
                        </div>
                    </fullscreen>
                </div>
            </div>
            <div class="row mt-3">
                <!-- Open Count Section -->
                <div class="col-lg-8 col-md-8 col-sm-12 pr-3">
                    <fullscreen class="box-radius bg-white" ref="camp_count" @change="dataChange('camp_count')" >
                        <div class="p-3">
                            <div class="d-flex justify-content-between aline-items-center mt-1">
                                <div class="fw-600 fs-14">Open Count</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('camp_count'), campCountExpand()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div v-if="dateRange.length" style="border-bottom: 1px solid #a9aaad;">
                                <div class="d-flex justify-content-between align-items-center"
                                    style="background: #41b883; border-radius: 12px; padding-left: 10px; padding-right: 10px; margin-top: 4px; margin-bottom: 8px; width: 16em;">
                                    <input type="text"
                                        :value="('0'+new Date(dateRange[0]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[0]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[0]).getFullYear()+' to '+('0'+new Date(dateRange[1]).getDate()).slice(-2)+'/'+('0'+(new Date(dateRange[1]).getMonth()+1)).slice(-2)+'/'+new Date(dateRange[1]).getFullYear()"
                                        style="color: #fff; background: #41b883; width: 14em;" disabled />
                                    <span
                                        @click="dataClose(),dateRange= []"
                                        style="color: #fff; cursor: pointer;">&#10005;</span>
                                </div>
                            </div>
                            <date-picker v-else @change="updatecreationDate()" v-model="dateRange" format="DD/MM/YYYY"
                                    range class="date-width calendar-edit-per callreport-listdate calendar-height-top" :show-second="false"
                                :lang="lang" :clearable="true" confirm :not-after="new Date()" confirm-text="APPLY" type="date">
                            </date-picker>
                        </div>
                        <div class="d-flex align-items-center justify-content-center mt-3" v-if="loadCampaignsOpenCountSection" style="height: 324px;">
                            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div v-else class="card-item bg-white text-auto pb-0">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div id="campCountDiv" class="mt-3 campCountDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
                <!-- Campaign Type Section -->
                <div class="col-lg-4 col-md-4 col-sm-12 pl-0">
                    <fullscreen class="box-radius bg-white" ref="camp_type" @change="dataChange('camp_type')" >
                        <div class="card-item-camp-type bg-white text-auto pb-0">
                            <div class="d-flex justify-content-between aline-items-center pt-4 pr-4 pl-4">
                                <div class="fw-600 fs-14">Campaign Type</div>
                                <button type="button" class="pointer bg-white icon-outline-css" @click="expandData('camp_type'), campTypeExpand()">
                                    <img class="expand-img" src="/static/images/exapand.svg" alt />
                                </button>
                            </div>
                            <div class="d-flex align-items-center justify-content-center mt-3" v-if="loadCampaignTypeSection" style="height: 370px;">
                                <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                            </div>
                            <div v-else class="row">
                                <div class="col-lg-12">
                                    <div id="campTypeDiv" class="mt-3 campTypeDiv"></div>
                                </div>
                            </div>
                        </div>
                    </fullscreen>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { onMounted } from 'vue'
import campaignList from "../mixins/campaign.js"
import { HalfCircleSpinner } from "epic-spinners";
import convert from "../mixins/convert.js";
export default {
    data(){
        return{
            loadCampaignTypeSection: false,
            loadCampaignsOpenCountSection: false,
            loadCampaignStatisticSection: false,
            currency_symbol: '',
            activeItem: 0,
            ajaxCallInProgress: false,
            ajaxCallInProgress_campList: false,
            period_data:'fiscal_year',
            time_period: 'fiscal_year',
            between:'',
            creation_date: [],
            camp_type_data: [],
            campaigns_list: [],
            created_report_date: [new Date() , new Date()],
            rangeDate: [],
            dateRange: [],
            graph_scale:[],
            scale_data: [],
            campaign_stats_data: [],
            selected_campaign_name: "",
            selected_campaign_id: "",
            selected_campaign_type: "",
            selected_campaign_start_date: "",
            selected_campaign_category_id: "",
            camp_open_count: [],
            lang: {
                type: "en",
                days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                months: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days"
                ],
                placeholder: {
                    date: "Select Date",
                    dateRange: "Select Date Range"
                },


            },
        }
    },
    mixins: [campaignList, convert],
    components: {
        HalfCircleSpinner,
    },
    methods: {
        //To highlight first row in table
        selectItem(i) {
            this.activeItem = i;
        },
        //Full screen section change
        dataChange(value) {
            if(value == 'camp_list'){
                this.sales = value;
                this.campList();
            }else if(value == 'camp_stats'){
                this.sales = value;
                this.campStatsExpand();
            }else if(value == 'camp_count'){
                this.sales = value;
                this.campCountExpand();
            }else if(value == 'camp_type'){
                this.sales = value;
                this.campTypeExpand();
            }
        },
        campList(){
            var campListData = document.getElementById('campListValue');
            campListData.classList.toggle('campListValue');
            campListData.classList.toggle('campListValue-expand');
        },
        campStatsExpand(){
            var campStats = document.getElementById('campStatsDiv');
            campStats.classList.toggle('campStatsDiv');
            campStats.classList.toggle('campStatsDiv-expand');
        },
        campCountExpand(){
            var campCount = document.getElementById('campCountDiv');
            campCount.classList.toggle('campCountDiv');
            campCount.classList.toggle('campCountDiv-expand');
        },
        campTypeExpand(){
            var campCount = document.getElementById('campTypeDiv');
            campCount.classList.toggle('campTypeDiv');
            campCount.classList.toggle('campTypeDiv-expand');
        },
        expandData(value) {
            if(value == 'camp_list'){
                this.$refs["camp_list"].toggle();
                this.campList();
            }else if(value == 'camp_stats'){
                this.$refs["camp_stats"].toggle();
                this.campStatsExpand();
            }else if(value == 'camp_count'){
                this.$refs["camp_count"].toggle();
                this.campCountExpand();
            }else if(value == 'camp_type'){
                this.$refs["camp_type"].toggle();
                this.campTypeExpand();
            }
        },
        dataClose(){
            let date = this.rangeDate
            let start_date = this.convertFilter(date[0])
            let end_date = this.convertFilter(date[1])
            let newValue = start_date + ',' + end_date
            newValue = newValue.split(",")
            this.created_report_date = newValue
            this.loadCampOpenCountAPI()
        },
        updatecreationDate(){
            if (this.dateRange) {
                let start_date = this.convertFilter(this.dateRange[0])
                let end_date = this.convertFilter(this.dateRange[1])
                let newValue = start_date + ',' + end_date
                newValue = newValue.split(",")
                this.created_report_date = newValue
                this.loadCampOpenCountAPI()
            } else {
                this.creation_date = ''
                this.created_report_date = ''
            }
            this.$forceUpdate()

        },
        dateSettings(){
            let date = []
            var dateOffset = (24*60*60*1000) * (365*5); //5 yrs
            var newDate = this.convertFilter(new Date());
            var oldDate = new Date();
            oldDate.setTime(oldDate.getTime() - dateOffset);
            this.created_report_date= [this.convertFilter(oldDate),newDate]
            this.rangeDate = [this.convertFilter(oldDate),newDate]
        },
        //API call to load campaign count details
        async loadCampOpenCountAPI(){
            this.loadCampaignsOpenCountSection = true;
            try {
                let params ={
                    range: this.created_report_date
                }
                let response = await this.getCampOpenCountAPI(params)
                this.camp_open_count = response.response.timing
                const result = []
                const map = new Map();
                for (const item of this.camp_open_count) {
                    map.set(item.opens, true);
                    result.push({
                        date: item.period || '',
                        value:item.opens
                    });
                }
                this.graph_scale = response.response.graph_scale
                const scale = []
                for (const scaledata of this.graph_scale) {
                    scale.push(scaledata)
                }
                this.graph_scale = scale
                this.camp_open_count = result
                this.loadCampaignsOpenCountSection = false;
            } catch (reason) {
                this.loadCampaignsOpenCountSection = false;
            }
            if(this.graph_scale == ''){
                this.loadCampaignsOpenCountSection = false;
                setTimeout(() => {
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.campCountDataCss {width: 30%!important;height: 60%!important;margin:auto!important;margin-top:20px !important}';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('campCountDiv').innerHTML = "<div class=text-center pt-10><img id= campOpenCountData-img src=/static/images/response.png class=mt-10><div class='mt-4 text-muted fw-500'>No Campaigns created!</div></div>";
                    document.getElementById('campOpenCountData-img').className = 'campCountDataCss';
                }, 1000);
            } else {
                this.loadCampaignsOpenCountSection = false;
                this.loadCampOpenCountData()
            }
            this.loadCampaignsOpenCountSection = false;
        },
        //Amchart code to campaign count section 
        loadCampOpenCountData() {
            setTimeout(() => {
                let vueThis = this
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                var chart = am4core.create("campCountDiv", am4charts.XYChart);
                chart.paddingRight = 40;

                var data = [];
                var value = 50;
                for (let i = -3650; i < 0; i++) {
                let date = new Date();
                date.setHours(0, 0, 0, 0);
                date.setDate(i);
                value -= Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
                if (value < 0) {
                    value = Math.round(Math.random() * 10);
                }
                data.push({ date: date, value: value });
                }

                chart.data = this.camp_open_count;

                // Create axes
                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.minGridDistance = 60;
                dateAxis.groupData = true;
                dateAxis.title.text = "Period"
                dateAxis.title.fontWeight = 600;

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = "Opens";
                valueAxis.title.fontWeight = 600;
                valueAxis.min = 0;
                //create label
                var ylabel = valueAxis.renderer.labels.template;
                ylabel.truncate = true;
                ylabel.maxWidth = 80;
                ylabel.tooltipText = "{value}";

                // Create series
                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "value";
                series.dataFields.dateX = "date";
                series.tooltipText = "{value}"

                series.tooltip.pointerOrientation = "vertical";

                chart.cursor = new am4charts.XYCursor();

                chart.scrollbarX = new am4core.Scrollbar();
            }, 1000);
        },
        //To set half year, quarterly time period value 
        getData(value){
            this.period_data = value
            if(value == 'h1'|| value == 'h2' ){
                this.time_period = 'semi_annual'
                this.between = value
            }
            else if(value == 'q1'|| value == 'q2' || value == 'q3' || value == 'q4'){
                this.time_period = 'quarter'
                this.between = value
            } else {
                this.time_period = value
                this.between = ''
            }
            this.getCampaigns();
            this.loadCampaignTypeData();
        },
        //API call to get campaign type data 
        async loadCampaignTypeData(){
            this.loadCampaignTypeSection = true;
            let params = {
                period: this.time_period,
                between: this.between
            }
            let response = await this.getCampaignTypeData(params)
            this.camp_type_data = response.response
            this.loadCampaignTypeSection = false;

            setTimeout(() => {
                
                // Create chart instance
                var chart = am4core.create("campTypeDiv", am4charts.PieChart);

                // Add data

                if(this.camp_type_data.email.percentage == 0 && this.camp_type_data.sms.percentage == 0){
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.campTypeDataCss {width: 60%!important;height: 60%!important;margin:auto!important;margin-top:45px !important}';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('campTypeDiv').innerHTML = "<div class=text-center><img id= campType-img src=/static/images/survey-type.png class=mt-10><div class='mt-5 text-muted fw-500'>No Campaigns!</div></div>";
                    document.getElementById('campType-img').className = 'campTypeDataCss';
                } else {
                    chart.data = [{
                    "country": "Email",
                    "litres": this.camp_type_data.email.percentage
                    }, {
                    "country": "SMS",
                    "litres": this.camp_type_data.sms.percentage
                    }];

                    // Add and configure Series
                    var pieSeries = chart.series.push(new am4charts.PieSeries());
                    pieSeries.dataFields.value = "litres";
                    pieSeries.dataFields.category = "country";
                    //pieSeries.dataFields.hidden = "hidden";

                    // Let's cut a hole in our Pie chart the size of 40% the radius
                    chart.innerRadius = am4core.percent(40);

                    // Disable ticks and labels
                    pieSeries.labels.template.disabled = true;
                    pieSeries.ticks.template.disabled = true;

                    // Disable tooltips
                    pieSeries.slices.template.tooltipText = "";

                    // Add a legend
                    chart.legend = new am4charts.Legend();
                    chart.legend.position = "right";
                }
            }, 1000);
        },
        //Redirects to create campaign page
        goToCreateEmailCampaign(){
            this.$router.push('/campaign/email/createCampaignEmail/')
        },
        // goToCreateSmsCampaign(){
        //     this.$router.push('/campaign/sms/createCampaignSms/')
        // },
        loadCampaignDetails(id, name, type, start_date, category_id){
            this.selected_campaign_name = name;
            this.selected_campaign_id = id;
            this.selected_campaign_type = type;
            this.selected_campaign_start_date = start_date;
            this.selected_campaign_category_id = category_id;
            this.getCampaignStatisticsAPI();
        },
        //API call to get campaigns statistics data
        async getCampaignStatisticsAPI(){
            this.loadCampaignStatisticSection = true;
            if(this.campaigns_list.length != 0){
                try{
                    let params = {
                        category_id: this.selected_campaign_category_id,
                        type: this.selected_campaign_type,
                    }
                    let response = await this.getCampaignStatisticsData(params)
                    this.campaign_stats_data = response.response.timing
                    this.scale_data = response.response.graph_scale
                    const result = []
                    const map = new Map();
                    for (const item of this.campaign_stats_data) {
                        let newArr = []
                        item.parameter.replaceAll("_", " ").split(" ").forEach((el, elindex) =>{
                            newArr.push(el[0].toUpperCase() + el.substring(1) + " ")
                        })
                        result.push({
                            country: newArr.join(" "),
                            visits:item.count
                        });
                    }
                    this.campaign_stats_data = result
                    for (const scaledata of this.scale_data) {
                        scale.push(scaledata)
                    }
                    this.loadCampaignStatisticSection = false;
                    this.scale_data = scale
                } catch (reason) {
                    this.loadCampaignStatisticSection = false;
                }
                this.loadCampaignStatisticsData()
            } else {
                this.loadCampaignStatisticSection = false;
                setTimeout(() => {
                    var style = document.createElement('style');
                    style.type = 'text/css';
                    style.innerHTML = '.campStatsTypeCss {width: 350px !important;height: 220px;margin: auto !important;margin-top:30px !important;  }';
                    document.getElementsByTagName('head')[0].appendChild(style);
                    document.getElementById('campStatsDiv').innerHTML = "<div class=text-center><img id= campStatType-img src=/static/images/response.png class=mt-3><div class='mt-4 text-muted fw-500'>No Statistics found! </div></div>";
                    document.getElementById('campStatType-img').className = 'campStatsTypeCss';
                }, 1000);
            }
            this.loadCampaignStatisticSection = false;
        },
        //Amchart code to show campaigns statistics data 
        async loadCampaignStatisticsData(){
            setTimeout(() => {
                let vueThis = this
                let scale = vueThis.scale_data
                am4core.useTheme(am4themes_animated);
                var chart = am4core.create("campStatsDiv", am4charts.XYChart);
                chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                chart.data = vueThis.campaign_stats_data
                var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.dataFields.category = "country";
                categoryAxis.renderer.minGridDistance = 10;
                categoryAxis.title.text = "Parameters";
                categoryAxis.title.fontWeight = 600;
                categoryAxis.renderer.grid.template.disabled = true;
                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.renderer.grid.template.location = 0;
                valueAxis.dataFields.category = "visits";
                valueAxis.renderer.minGridDistance = 100;
                valueAxis.title.text = "Reference number";
                valueAxis.title.fontWeight = 600;
                //valueAxis.numberFormatter.numberFormat = "#a";
                //create label
                var label = categoryAxis.renderer.labels.template;
                label.truncate = true;
                label.maxWidth = 80;
                label.tooltipText = "{country}";
                var ylabel = valueAxis.renderer.labels.template;
                ylabel.truncate = true;
                ylabel.maxWidth = 50;
                ylabel.tooltipText = "{value}";

                categoryAxis.events.on("sizechanged", function(ev) {
                var axis = ev.target;
                var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
                if (cellWidth < axis.renderer.labels.template.maxWidth) {
                    axis.renderer.labels.template.rotation = -90;
                    axis.renderer.labels.template.horizontalCenter = "right";
                    axis.renderer.labels.template.verticalCenter = "middle";
                }
                else {
                    axis.renderer.labels.template.rotation = 0;
                    axis.renderer.labels.template.horizontalCenter = "middle";
                    axis.renderer.labels.template.verticalCenter = "top";
                }
                });
                var series = chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.categoryX = "country";
                series.dataFields.valueY = "visits";
                series.columns.template.tooltipText = "{valueY.value}";
                series.columns.template.tooltipY = 0;
                series.columns.template.strokeOpacity = 0;

                var valueLabel = series.bullets.push(new am4charts.LabelBullet());
                valueLabel.label.text = "{visits}";
                valueLabel.label.fontSize = 8;
                valueLabel.label.fontWeight = 600;
                valueLabel.label.horizontalCenter = "top";
                valueLabel.label.verticalCenter = "top";
                valueLabel.label.fill = am4core.color("#ffffff");
                valueLabel.label.dx = -11;
                valueLabel.label.dy = 10;
                // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
                series.columns.template.adapter.add("fill", (fill, target) => {
                return chart.colors.getIndex(target.dataItem.index);
                });
            //scaleData();
                function scaleData(){
                    for(let j=0;j<scale.length;j++){
                        createGrid(scale);
                    }
                }
                function createGrid(value) {
                    var range = valueAxis.axisRanges.create();
                    range.value = value;
                    range.label.text = value;
                }
            }, 1000);
        },
        //API call to get all campaigns data 
        async getCampaigns() {
            try {
                this.activeItem = 0;
                this.loadCampaignStatisticSection = true;
                this.ajaxCallInProgress_campList = true;
                let params = {
                    limit: 10,
                    skip: 0,
                    period: this.time_period,
                    between: this.between,
                    search_key: "",
                    type: "email",
                    "filter_json": {
                        "status": ["approved"],
                    },
                };
                let response = await this.getCampaignListDashboards(params)
                this.campaigns_list = response.response
                this.selected_campaign_name = this.campaigns_list.length != 0 ? this.campaigns_list[0].name : "";
                this.selected_campaign_id = this.campaigns_list.length != 0 ? this.campaigns_list[0]._id : "";
                this.selected_campaign_type = this.campaigns_list.length != 0 ? this.campaigns_list[0].type : "";
                this.selected_campaign_start_date = this.campaigns_list.length != 0 ? this.campaigns_list[0].start_date : "";
                this.selected_campaign_category_id = this.campaigns_list.length != 0 ? this.campaigns_list[0].category_id : "";
                this.ajaxCallInProgress_campList = false;
                this.getCampaignStatisticsAPI();
            }
            catch (error) {
            }
        },
    },
    async mounted(){
        // this.loadCampaignStatisticSection = true;
        // this.ajaxCallInProgress = true;
        this.dateSettings();
        this.loadCampaignTypeData();
        this.loadCampOpenCountAPI();
        this.getCampaigns();
        this.currency_symbol = this.loggedInUser.currency.symbol;
        setTimeout(() => {
            // this.dateSettings();
            // this.loadCampaignTypeData();
            // this.loadCampOpenCountAPI();
            // this.getCampaigns();
            (function() {
            $(function() {
                    $('.period-dropdown > a').on('click', function(e) {
                    var submenu;
                    submenu = $(this);
                    $('.period-dropdown .period-dropdown-menu').removeClass('show');
                    submenu.next('.period-dropdown-menu').addClass('show');
                    e.stopPropagation();
                    });
                    return $('.perioddropdown').on('hidden.bs.dropdown', function() {
                    // hide any open menus when parent closes
                    $('.period-dropdown-menu.show').removeClass('show');
                    });
                });
            }).call(this);
            // this.ajaxCallInProgress = false;
        }, 2000);

    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
        userPermissions(){
            return this.$store.getters.userPermissions;
        },
    },
}
</script>
<style scoped>
    .dropdown-label{
        font-size: 16px;
        font-weight: 400;
        margin-right: 8px;
    }
    .dropdown-button{
        background-color: #fff !important;
        height: 30px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        padding: 0 1.5rem;
    }
    .dropdown-button:focus{
        border: 1px solid #00448b !important;
    }
    .dropdown-button span{
        color: #000;
        font-weight: 400;
    }
    .dropdown-menu {
        top: 4px !important;
        left: 10px !important;
        margin-top: -1px;
        border-radius: 8px;
    }
    .dropdown-item-toggle {
        margin-right:5px;
    }
    .dropdown-item-toggle::after {
        position: absolute;
        right: 7px;
        content: '▸';
        color: #aaa;
        margin-left: 0.5rem;
    }
    .dropdown-submenu {
        position: relative;
        padding: 0;
    }
    .sub-dropdown{
        left: -80% !important;
        width: 78%;
        margin: 0px;
        padding: 0px;
    }
    .campListValue {
        width: 103%;
        height: 340px;
        border: 1px solid #7faed6;
        border-radius: 5px;
        overflow: overlay;
        margin-left: -17px;
    }
    .campListValue-expand{
        width: 100%;
        height: 820px;
        border-radius: 5px;
        overflow:scroll !important;
    }
    .table-properties {
        border-collapse: collapse;
        max-height: 336px;
        width: 100%;
    }
    table thead th,
    table tbody td {
        padding: 10px;
    }
    .team-listview-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 5px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
    }
    .team-listview-table thead tr th:first-child {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }
    .team-listview-table thead tr th:last-child {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    .box-radius{
        border-radius: 7px !important;
    }
    .card-item {
        padding: 18px 18px 30px 37px;
        border-radius: 6px;
    }
    .card-item-camp-type {
        border-radius: 6px;
    }
    .card-item-contact {
        padding: 18px;
        border-radius: 6px;
    }
    .deals-cards {
        padding: 18px !important
    }
    .campStatsDiv{
        width: 100%;
        height: 358px;
        max-height: 100%;
    }
    .campStatsDiv-expand{
        width: 100%;
        height: 750px;
        max-height: 100%;
        padding: 90px;
    }
    .expand-img {
        width: 20px;
        margin-bottom: 2px;
        color: #00448b !important;
    }
    .campCountDiv {
        width: 100%;
        height: 306px;
    }
    .campCountDiv-expand {
        width: 100%;
        height: 650px;
    }
    .campTypeDiv {
        width: 100%;
        height: 370px;
    }
    .campTypeDiv-expand {
        width: 100%;
        height: 650px;
    }
    .text-color{
        color: #338DF1;
    }
    .cell-width{
        max-width: 100px;
    }
    .cell-width-name{
        max-width: 380px;
    }
    .camp-table-row:hover{
        box-shadow: 0px 0px 6px darkgray;
        cursor: pointer;
    }
    .active{
        box-shadow: 0px 0px 6px darkgray;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/CampaignsDashboard.vue